import { Button, Clickable, Col, Input, Text } from 'components';
import { Api, theme, validateEmail } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container } from '../components';

const MigratedUser = () => {
  const [email, setEmail] = useState(useLocation()?.state?.email || ''),
    { isMobile } = useSelector((state) => state.appState),
    disabled = !validateEmail(email),
    { t } = useTranslation(),
    navigate = useNavigate();

  async function submit() {
    const res = await Api.post('/users/validateEmail', { email }, 'validateEmail');
    if (!res) return;
    if (!res || res.noUserFound) return;

    navigate('/validation-email-sent');
  }

  return (
    <Container>
      <Col marg="28px 0 0" center noFlex wid="100%">
        <Text h1 center>
          {t('auth.validateYourEmail')}
        </Text>

        <Text col={theme.GREY_60} marg="8px" center wid={isMobile ? 'calc(100vw - 16px)' : '456px'}>
          {t('auth.validateEmailInstructions')}
        </Text>

        <Col center>
          <Input
            marg="32px 0 0"
            wid="296px"
            placeholder={t('common.email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Button
            marg="28px 0 0"
            wid="296px"
            disabled={disabled}
            text={t('auth.confirmEmail')}
            bg={theme.SECONDARY}
            app
            onClick={submit}
            action="validateEmail"
          />
        </Col>

        <Clickable onClick={() => navigate('/login')} marg="27px 0 0">
          <Text b2 center bold>
            {t('auth.backTo')} {t('auth.logIn')}
          </Text>
        </Clickable>
      </Col>
    </Container>
  );
};

export default MigratedUser;
